import React from 'react';
import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string; // Si no tiene path, es el último item (no clickeable)
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  light?: boolean; // Para fondos oscuros, texto claro
}

export default function Breadcrumb({ items, light = false }: BreadcrumbProps) {
  return (
    <nav aria-label="breadcrumb" className={light ? '' : 'mb-4'}>
      <ol className={`breadcrumb ${light ? 'bg-transparent mb-0' : 'bg-light p-3 rounded'}`}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li
              key={index}
              className={`breadcrumb-item ${isLast ? 'active' : ''} ${light ? 'text-white-50' : ''}`}
              aria-current={isLast ? 'page' : undefined}
            >
              {isLast || !item.path ? (
                <span className={light && isLast ? 'text-white' : ''}>{item.label}</span>
              ) : (
                <Link
                  to={item.path}
                  className={`text-decoration-none ${light ? 'text-white-50' : ''}`}
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
